import type { SuggestedListItem } from '../../hooks/useSuggestedList'

type Props = {
  items:       SuggestedListItem[]
  loading:     boolean
  onStartList: () => void
}

export function SuggestedListCard({ items, loading, onStartList }: Props) {
  const count      = items.length
  const shownChips = items.slice(0, 3)
  const overflow   = count - shownChips.length
  const outCount   = items.filter(i => i.reason === 'out').length
  const reason     = outCount > 0 ? "what you're out of" : "what's running low"

  return (
    <section className="relative mb-[14px] overflow-hidden rounded-[18px] bg-forest p-4 text-forest-ink">
      <div className="mb-2">
        <span className="text-[10px] font-medium uppercase tracking-[0.15em] text-sand">
          Suggested list
        </span>
      </div>

      <h2 className="font-serif text-[22px] font-normal leading-[1.15] tracking-[-0.005em]">
        {count} {count === 1 ? 'item' : 'items'} based on{' '}
        <em className="italic text-sand">{reason}</em>
      </h2>

      <div className="mt-[10px] flex flex-wrap gap-1">
        {shownChips.map(item => (
          <span
            key={item.itemId}
            className="rounded-[6px] bg-white/15 px-2 py-[3px] text-[10px] font-medium text-forest-ink"
          >
            {item.name}
          </span>
        ))}
        {overflow > 0 && (
          <span className="rounded-[6px] bg-white/15 px-2 py-[3px] text-[10px] font-medium text-forest-ink">
            + {overflow} more
          </span>
        )}
      </div>

      <button
        onClick={onStartList}
        disabled={loading}
        className="mt-[14px] w-full rounded-[10px] bg-cream px-3 py-[10px] text-[12px] font-bold tracking-[-0.01em] text-forest disabled:opacity-60"
      >
        {loading ? 'Creating list…' : 'Start this list'}
      </button>
    </section>
  )
}
